export default __webpack_public_path__ + "static/media/TheWorldBrazil_09.735f92c1.png";